/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import Swiper from 'swiper';
import imagesLoaded from 'imagesloaded';
import 'jquery.marquee';
import 'isotope-layout/dist/isotope.pkgd';

$(document).ready(() => {
  // navbar handling
  // https://gist.github.com/sarvar/79ecdc7c97bbdc9d6debf94fc19e57cb
  var stickyToggle = function(sticky, stickyWrapper, scrollElement) {
    var stickyHeight = sticky.outerHeight();
    var stickyTop = stickyWrapper.offset().top;
    if (scrollElement.scrollTop() >= stickyTop){
      stickyWrapper.height(stickyHeight);
      sticky.addClass("is-sticky");
    }
    else{
      sticky.removeClass("is-sticky");
      stickyWrapper.height('auto');
    }
  };

  // Find all data-toggle="sticky-onscroll" elements
  $('[data-toggle="sticky-onscroll"]').each(function() {
    var sticky = $(this);
    var stickyWrapper = $('<div>').addClass('sticky-wrapper'); // insert hidden element to maintain actual top offset on page
    sticky.before(stickyWrapper);
    sticky.addClass('sticky');

    // Scroll & resize events
    $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function() {
      stickyToggle(sticky, stickyWrapper, $(this));
    });

    // On page load
    stickyToggle(sticky, stickyWrapper, $(window));
  });

  // fix menu background
  $('.banner .navbar-collapse').on('hide.bs.collapse', function (e) {
    if ($(this).is(e.target)) {
      $('#navbarMobile').removeClass('background-fill');
      $('.hamburger').removeClass('is-active');
    } else {
    //  console.log('close: xxx');
    }
  })

  $('.banner .navbar-collapse').on('show.bs.collapse', function (e) {
    if ($(this).is(e.target)) {
      $('.hamburger').addClass('is-active');
    }
  })

  $('.banner .navbar-collapse').on('shown.bs.collapse', function (e) {
    if ($(this).is(e.target)) {
      $('#navbarMobile').addClass('background-fill');
    } else {
    //  console.log('open: xxx');
    }
  })

  // fix accordion behavior
  $('#superar_locations .country-collapse').on('hide.bs.collapse', function (e) {
    if ($(this).is(e.target)) {
      $(this).parent().removeClass('fill');
      var supermap = $(this).attr('data-map');
      $(supermap).removeClass('is-active');
    } else {
    //  console.log('close: xxx');
    }

  })

  $('#superar_locations .country-collapse').on('show.bs.collapse', function (e) {
    if ($(this).is(e.target)) {
      $(this).parent().addClass('fill');
      var supermap = $(this).attr('data-map');
      $(supermap).addClass('is-active');
    //  console.log('open: ' + this.id);
    } else {
    //  console.log('open: xxx');
    }
  })

  //
  $('.btn-workshop').on('click',function(){
    var dataURL = $(this).attr('data-href');
    var dataTarget = $(this).attr('data-target') + ' iframe';
    $(dataTarget).attr('src',dataURL);
    /*
    $('.modal-body').load(dataURL,function(){
      $(dataTarget).modal({show:true});
    });
    */
  });

  $('.readonly textarea').attr("readonly","readonly");

  // init Isotope
  var $grid = $('.elements').isotope({
    itemSelector: '.element-item',
    transitionDuration: 0,
    // layoutMode: 'fitRows',
    masonry: {
      // use element for option
      columnWidth: '.element-item',
    },
  });

  // bind filter button click
  var $filters;
  $filters = $('.filters').on( 'click', '.btn-filter', function() {
    var $this = $( this );
    var filterValue;
    if ( $this.is('.is-checked') ) {
      // uncheck
      filterValue = '*';
    } else {
      filterValue = $this.attr('data-filter');
      $filters.find('.is-checked').removeClass('is-checked');
    }
    $this.toggleClass('is-checked');

    $grid.isotope({ filter: filterValue });
  });

  $('.collapse').on('shown.bs.collapse', function () {
    $grid.isotope();
  })

  $('.collapse').on('hidden.bs.collapse', function () {
    $grid.isotope();
  })

  $('body').imagesLoaded( function() {
    $('html').addClass('imagesLoaded');
    $grid.isotope();
  });

  /* eslint-disable */
  var fullwidthSwiper = new Swiper ('.swiper-fullwidth', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 2000,
    loop: true,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  var scrollSwiper = new Swiper('.scroll-container', {
    direction: 'vertical',
    slidesPerView: 'auto',
    freeMode: true,
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    mousewheel: true,
  })

  var scrollSwiper = new Swiper('.scroll-container-snap', {
    direction: 'vertical',
    slidesPerView: 'auto',
    // freeMode: true,
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    mousewheel: true,
  })

/*
  var swiperEvent1 = new Swiper('.swiper-event-1', {
    slidesPerView: '1',
    loop: true,
    // centeredSlides: true,
    // slidesPerView: 3,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    },
  })

  var swiperEvent2 = new Swiper('.swiper-event-2', {
    slidesPerView: '1',
    loop: true,
    // centeredSlides: true,
    // slidesPerView: 3,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    },
  })
*/

  var $sContain = $('.swiper-event');
  var $i = 0;
  var $events = [];

  $sContain.each(function(){
    $events[$i] = new Swiper($(this), {
      keyboard: {
        enabled: true,
      },
      loop: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: $(this).find('.swiper-button-next'),
        prevEl: $(this).find('.swiper-button-prev'),
      },
    });
  })

  var swiper2x = new Swiper('.swiper-2x', {
    slidesPerView: 'auto',
    loop: true,
    // centeredSlides: true,
    // slidesPerView: 3,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    },
  })

  var swiper3x = new Swiper('.swiper-3x', {
    slidesPerView: 'auto',
    loop: true,
    centeredSlides: true,
    // slidesPerView: 3,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    },
  })

  /*
  var dynaSlider = new Swiper ('.swiper-container', {
    loop: true,
    spaceBetween: 30,
    // centeredSlides: true,
    // speed: 2000,
    // effect: 'fade',
    // autoplay: {
    //  delay: 7000,
    //  disableOnInteraction: false,
    // },
  })
  */
  /* eslint-enable */

/*
  $( ".ejecteject" ).each(function(index) {
    $(this).on("click", function(){
      $('.swiper-lightbox .swiper-wrapper').html($('.source').html());
      console.log('Wolf');
      var dynaSlider = new Swiper ('.swiper-lightbox', {
        loop: true,
        spaceBetween: 30,
        initialSlide: 3,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        on: {
          init: function () {
            console.log('swiper initialized');
            $( ".swiper-lightbox .close-swiper" ).each(function(index) {
              $(this).on("click", function(){
                console.log('close');
                dynaSlider.destroy();
                // insert class handling
                $('.swiper-lightbox .swiper-wrapper').html('');
              });
            });
          },
        },
      });
    });
  });

  $( ".abort" ).each(function(index) {
    $(this).on("click", function(){
      console.log('abort');
      // dynaSlider.destroy();
    });
  });
*/

  // marquee
  // https://github.com/aamirafridi/jQuery.Marquee
  $('.marquee').marquee({
    setStartPosition: 100,
    startVisible: true,
    duration: 20000,
    duplicated: true,
    gap: 50,
  });
  
  // Funktion zum Öffnen des passenden Accordions basierend auf der URL
  function openAccordionFromHash() {
    var hash = window.location.hash;
    if (hash) {
      var targetId = '#collapse-' + hash.substring(1); // "collapse-" vor den Hash setzen
      var target = $(targetId + '.collapse'); // Prüfen, ob das Element existiert
  
      if (target.length) {
        target.collapse('show'); // Bootstrap Methode zum Öffnen eines Accordions
        $('html, body').animate({ scrollTop: target.offset().top - 100 }, 500); // Optional: sanft scrollen
      }
    }
  }
  
  // Beim Laden der Seite ausführen
  openAccordionFromHash();
  
  // Falls die URL sich ändert (z. B. durch Navigation oder manuelles Ändern), erneut prüfen
  $(window).on('hashchange', function() {
    openAccordionFromHash();
  });
});
